import Vue from 'vue';
import Vuebar from 'vuebar';
import App from './App.vue';
import './assets/styles/base.scss';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

Vue.use(Vuebar);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

if ('serviceWorker' in navigator) {
  addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registered:', registration);
      })
      .catch(error => {
        console.error(`Service worker registration failed: ${error}`);
      });
  });
}
